import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './SettingsModal.css';

/**
 * 通用设置弹窗组件
 * 支持动态配置不同的设置项
 * 
 * @param {boolean} isOpen - 弹窗是否打开
 * @param {function} onClose - 关闭弹窗回调
 * @param {function} onStart - 点击开始按钮回调，接收settings对象
 * @param {string} title - 弹窗标题
 * @param {array} settingItems - 设置项配置数组
 * @param {object} defaultSettings - 默认设置值
 */
const SettingsModal = ({ 
  isOpen, 
  onClose, 
  onStart, 
  title = '设置',
  settingItems = [],
  defaultSettings = {}
}) => {
  const [settings, setSettings] = useState(defaultSettings);

  // 当 defaultSettings 改变时，同步更新内部状态
  useEffect(() => {
    setSettings(defaultSettings);
  }, [defaultSettings]);

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleStart = () => {
    onStart(settings);
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="settings-modal-overlay">
      <div className="settings-modal">
        {/* 标题 */}
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
        </div>

        {/* 设置内容 */}
        <div className="modal-content">
          {settingItems.map((item) => (
            <div key={item.key} className="setting-item">
              <label className="setting-label">{item.label}:</label>
              <select 
                className="setting-select"
                value={settings[item.key]}
                onChange={(e) => {
                  const value = item.valueType === 'number' 
                    ? parseFloat(e.target.value) 
                    : e.target.value;
                  handleSettingChange(item.key, value);
                }}
              >
                {item.options.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        {/* 按钮区域 */}
        <div className="modal-actions">
          <button 
            className="start-btn"
            onClick={handleStart}
          >
            开始
          </button>
          <button 
            className="cancel-btn"
            onClick={handleCancel}
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

SettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onStart: PropTypes.func.isRequired,
  title: PropTypes.string,
  settingItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      valueType: PropTypes.oneOf(['number', 'string']),
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
          label: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  defaultSettings: PropTypes.object.isRequired
};

export default SettingsModal;

